<script>
	import { scale } from 'svelte/transition';
	import { closeModal } from '$lib/modal-store';
	import { onDestroy, onMount } from 'svelte';
	import KeyboardShortcut from '$lib/components/smol_ui/keyboardShortcut.svelte';
	import { t } from '$lib/i18n.svelte.js';
	/** @type {{ content: string, userInput?: string, buttonText?: string, placeholder?: string, explanation?: string, validateFunction?: (input: string) => boolean, maxLength?: number, suggestions?: string[], onConfirm: (input: string) => void, onCancel?: () => void }} */
	let {
		content,
		userInput = '',
		buttonText = t('info.confirm'),
		placeholder = 'Aa...',
		explanation = '',
		validateFunction = () => true,
		maxLength = 280,
		suggestions = [],
		onConfirm,
		onCancel = () => {}
	} = $props();
	if (content.startsWith('[') && content.endsWith(']')) content = content.slice(1, -1);
	let validated = $state(false);
	onMount(() => document.getElementById('inputFieldf')?.focus());
	onDestroy(() => {
		if (!validated) onCancel();
	});
</script>

<div
	role="dialog"
	class="modal z-40"
	in:scale|global={{ duration: 300, start: 0.94 }}
	out:scale|global={{ duration: 300, start: 0.94 }}
>
	<div
		class="dark:bg-ord-cardcolor-dark dark:border-ord-border-dark pointer-events-auto z-40 mx-4 flex w-[350px] flex-col items-start gap-3 rounded-2xl bg-white p-3 text-black shadow-lg transition-all dark:border dark:text-white"
	>
		<p class="mx-auto mt-4 w-full text-center text-xl font-semibold">{content}</p>
		{#if explanation}
			<p class="mx-auto w-full text-center text-sm">{@html explanation}</p>
		{/if}
		<!-- text area -->
		<textarea
			id="inputFieldf"
			bind:value={userInput}
			onkeydown={(e) => {
				if (e.key === 'Enter' && !e.shiftKey && validateFunction(userInput ?? '')) {
					e.preventDefault();
					validated = true;
					onConfirm(userInput);
					closeModal();
				}
			}}
			maxlength={maxLength}
			rows={suggestions.length > 0 ? 1 : 4}
			class="border-ord-border dark:border-ord-border-dark dark:bg-ord-darkgrey w-full rounded-lg border p-2"
			{placeholder}
		></textarea>

		<button
			class={'text-md ord-button w-full rounded-lg px-4 py-2 font-medium transition-all ' +
				(!validateFunction(userInput ?? '')
					? 'bg-ord-grey dark:bg-ord-darkgrey cursor-not-allowed dark:text-white'
					: 'bg-royal-blue dark:bg-royal-blue text-white dark:text-white')}
			disabled={!validateFunction(userInput ?? '')}
			onclick={() => {
				validated = true;
				onConfirm(userInput);
				closeModal();
			}}
		>
			{buttonText}
			<KeyboardShortcut shortcut="↵" />
		</button>

		{#if suggestions.length > 0}
			<hr
				class="border-ord-border dark:border-ord-border-dark mx-auto my-2 w-11/12 border-dashed"
			/>
			<div class="flex flex-wrap justify-center gap-1">
				{#each [...new Set(suggestions.filter((s) => s
								.toLowerCase()
								.includes(userInput.toLowerCase())))].slice(0, 10) as suggestion}
					<button
						class="bg-ord-grey dark:bg-ord-darkgrey hover:bg-royal-blue hvr-grow grow rounded-md px-2 py-1 text-sm font-medium text-black transition-all dark:text-white"
						onclick={() => {
							userInput = suggestion;
							validated = true;
							onConfirm(userInput);
							closeModal();
						}}
					>
						{suggestion}
					</button>
				{/each}
			</div>
		{/if}
	</div>
</div>

<style>
	.modal {
		position: fixed;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		pointer-events: none;
	}
</style>
